export const REGISTRATION_SAVED = 'signup:REGISTRATION_SAVED'
export const REGISTRATION_FAILED = 'signup:REGISTRATION_FAILED'

export default {
  REGISTRATION_SAVED,
  REGISTRATION_FAILED,
}
